import { ModalBody } from 'reactstrap';
import { ListGroupItem } from 'reactstrap';
import styled from 'styled-components';

export const StyledParagraph = styled.p`
  color: #6e7582;
`;

export const StyledModalBody = styled(ModalBody)`
  padding-bottom: 0px;
  padding-top: 16px;
`;

export const StyledListGroupItem = styled(ListGroupItem)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  border: none;
  border-bottom: 1px solid #f0f2f6;
  border-top: 1px solid #f0f2f6;

  .media-body {
    margin-left: 8px;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #333333;
    align-self: center;
  }

  &:first-child {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border: none;
  }

  &:last-child {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
`;

export const NotificationText = styled.span`
  margin: 0 0 0 8px;
`;

export const NotificationWrapper = styled.div`
  color: #28865e;
  font-size: 14px;
  line-height: 16px;
  font-weight: 900;
  display: flex;
  align-items: center;
`;

export const StyledStreamIcon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  background-color: #6b6b6b;
  border-radius: 2px;
  .icon {
    color: #ffffff;
  }
`;
